var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner-container"},[_c('div',{staticClass:"banner-header"},[_c('span',[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v(_vm._s(_vm.description))])]),_c('img',{attrs:{"src":require(`@/assets/${_vm.imageName}`),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }